import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oracle-cloud-erp',
  templateUrl: './oracle-cloud-erp.component.html',
  styleUrls: ['./oracle-cloud-erp.component.scss']
})
export class OracleCloudERPComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
